import { coreApi } from '$api'
import {
  CompanyDefaultWorkingHours,
  ICompanyDefaultWorkingHours,
  IKeyValueBindingModel,
  IPayrollPayCodeTypeMapping,
  KeyValueBindingModel,
  PayrollPayCodeTypeMapping,
} from '$models'
import { singletonQueryClient } from '$utils'
import { PayrollSystem, RulePayCodeType } from '$constants'

enum QueryKeys {
  CompanyDefaultWorkingHours = 'company-default-working-hours',
}

/**
 * Get all company default working hours
 * @returns Promise<CompanyDefaultWorkingHours[]>
 */
export const getCompanyDefaultWorkingHours = (): Promise<
  ICompanyDefaultWorkingHours[]
> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.CompanyDefaultWorkingHours],
    queryFn: async () => {
      return coreApi.getCompanyDefaultWorkingHours()
    },
  })
}

/**
 * Update all company default working hours
 * @returns Promise<ICompanyDefaultWorkingHours[]>
 */
export const updateCompanyDefaultWorkingHours = (
  companyDefaultWorkingHours: ICompanyDefaultWorkingHours[]
): Promise<ICompanyDefaultWorkingHours[]> => {
  return coreApi.updateCompanyDefaultWorkingHours(
    companyDefaultWorkingHours as CompanyDefaultWorkingHours[]
  )
}

/**
 * Update company preferences via key/value pairs
 */
export const updateCompanyPreferences = (
  preferences: IKeyValueBindingModel[]
): Promise<IKeyValueBindingModel[]> => {
  return coreApi.setCompanyPreferences(preferences as KeyValueBindingModel[])
}

/**
 * Get payroll pay code type mappings for a given payroll system
 */
export const getPayrollPayCodeTypeMappings = async (
  payrollSystem: PayrollSystem
): Promise<IPayrollPayCodeTypeMapping[]> => {
  const result = await coreApi.getPayrollPayCodeTypeMappings(payrollSystem)

  // Filter out NoExport as we don't want that exposed to the UI and were are phasing it out with LOADED-7044 (On Costs).
  return result.filter(
    (mapping) => mapping.payCodeType !== RulePayCodeType.NoExport
  )
}

/**
 * Update payroll pay code type mappings
 */
export const updatePayrollPayCodeTypeMappings = async (
  payrollSystem: PayrollSystem,
  mappings: IPayrollPayCodeTypeMapping[]
): Promise<IPayrollPayCodeTypeMapping[]> => {
  const result = await coreApi.updatePayrollPayCodeTypeMappings(
    payrollSystem,
    mappings as PayrollPayCodeTypeMapping[]
  )

  // Filter out NoExport as we don't want that exposed to the UI and were are phasing it out with LOADED-7044 (On Costs).
  return result.filter(
    (mapping) => mapping.payCodeType !== RulePayCodeType.NoExport
  )
}
